"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.literalArray = void 0;
function literalArray(...entries) {
    return entries;
}
exports.literalArray = literalArray;
//# sourceMappingURL=literal_array.js.map